import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* ========== BREADCRUMBS ========== */}
      <section className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/">Home</Link></li>
            <li>About Us</li>
          </ol>
          <h2>About SDtech Solutions</h2>
        </div>
      </section>

      {/* ========== ABOUT SECTION ========== */}
      <section id="about-page" className="about-page">
        <div className="container">

          {/* Company Intro */}
          <div className="row gx-0 mb-5">
            <div className="col-lg-6 d-flex flex-column justify-content-center">
              <div className="content" data-aos="fade-up">
                <h3>Who We Are</h3>
                <h2>
                  SDtech Solutions is a leading IT company dedicated to empowering
                  businesses with innovative technology solutions.
                </h2>
                <p>
                  Founded with a vision to bridge the gap between technology and business,
                  SDtech Solutions has grown into a trusted partner for companies across
                  industries. We specialize in Software Development, Web & Mobile App
                  Development, Digital Marketing, UI/UX Design, Cloud Services, AI/ML
                  Solutions, and Cybersecurity.
                </p>
                <p>
                  Our team of passionate developers, designers, and strategists work
                  together to deliver solutions that not only meet but exceed client
                  expectations. We believe in building long-term partnerships based on
                  trust, transparency, and results.
                </p>
              </div>
            </div>
            <div className="col-lg-6 d-flex align-items-center" data-aos="zoom-out">
              <img
                src="img/about1.jpg"
                className="img-fluid"
                alt="About SDtech Solutions"
              />
            </div>
          </div>

          {/* ========== MISSION & VISION ========== */}
          <div className="row gy-4 mb-5">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div className="box" style={{ background: "#f0f7ff", padding: "30px", borderRadius: "10px", height: "100%" }}>
                <i className="ri-eye-line" style={{ fontSize: "2.5rem", color: "#007bff" }} />
                <h3 style={{ marginTop: "15px" }}>Our Vision</h3>
                <p>
                  To become a globally recognized technology partner that empowers
                  businesses of all sizes to achieve digital excellence and sustainable
                  growth through innovative solutions.
                </p>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="300">
              <div className="box" style={{ background: "#f0fff4", padding: "30px", borderRadius: "10px", height: "100%" }}>
                <i className="ri-rocket-line" style={{ fontSize: "2.5rem", color: "#28a745" }} />
                <h3 style={{ marginTop: "15px" }}>Our Mission</h3>
                <p>
                  To deliver world-class IT solutions that solve real business problems,
                  drive innovation, and create lasting value for our clients, employees,
                  and communities.
                </p>
              </div>
            </div>
          </div>

          {/* ========== HOW WE WORK ========== */}
          <div className="mb-5">
            <header className="section-header">
              <h2>How We Work</h2>
              <p>Our proven process ensures successful project delivery every time</p>
            </header>

            <div className="row gy-4">
              {[
                { step: "01", icon: "ri-chat-3-line", title: "Discovery", desc: "We listen, understand your requirements, goals, and challenges." },
{ step: "02", icon: "ri-pencil-ruler-line", title: "Planning & Design", desc: "We create wireframes, prototypes, and detailed project plans." },
{ step: "03", icon: "ri-code-s-slash-line", title: "Development", desc: "Agile development with regular updates and sprint reviews." },
{ step: "04", icon: "ri-bug-line", title: "Testing & QA", desc: "Rigorous testing to ensure quality, security, and performance." },
{ step: "05", icon: "ri-rocket-2-line", title: "Launch", desc: "Seamless deployment with monitoring and optimization." },
{ step: "06", icon: "ri-customer-service-line", title: "Support", desc: "Ongoing maintenance, updates, and 24/7 technical support." },
              ].map((item, index) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={100 + index * 100}
                >
                  <div className="box" style={{
                    background: "white",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 5px 30px rgba(0,0,0,0.05)",
                    height: "100%",
                    textAlign: "center",
                  }}>
                    <span style={{
                      fontSize: "2rem",
                      fontWeight: "800",
                      color: "#007bff",
                      opacity: 0.3,
                    }}>
                      {item.step}
                    </span>
                    <i className={item.icon} style={{ fontSize: "2rem", color: "#007bff", display: "block", marginTop: "10px" }} />
                    <h4 style={{ marginTop: "15px" }}>{item.title}</h4>
                    <p style={{ color: "#666" }}>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ========== WHY CHOOSE US ========== */}
          <div className="row gy-4">
            <div className="col-lg-6" data-aos="fade-up">
              <img src="img/features-2.png" className="img-fluid" alt="Why Choose SDtech" />
            </div>
            <div className="col-lg-6 d-flex align-items-center" data-aos="fade-up" data-aos-delay="200">
              <div>
                <h3>Why Choose SDtech Solutions?</h3>
                {[
                  { title: "Experienced Team", desc: "10+ skilled professionals with diverse tech expertise." },
                  { title: "Client-First Approach", desc: "Your success is our priority — every decision is client-focused." },
                  { title: "Agile Methodology", desc: "Transparent, iterative development with regular updates." },
                  { title: "24/7 Support", desc: "Round the clock technical support and maintenance." },
                  { title: "Affordable Pricing", desc: "Premium quality at competitive prices — no hidden costs." },
                  { title: "On-Time Delivery", desc: "We respect deadlines and deliver on time, every time." },
                ].map((item, index) => (
                  <div className="d-flex mb-3" key={index}>
                    <i className="bi bi-check-circle-fill" style={{ color: "#28a745", fontSize: "1.2rem", marginRight: "12px", marginTop: "3px" }} />
                    <div>
                      <strong>{item.title}:</strong>{" "}
                      <span style={{ color: "#666" }}>{item.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}






